/* Bloom & Co. footer — progressive enhancement only.
   The footer is fully functional (accordions, newsletter form) without
   this file; it just adds small usability touches on top. */

(() => {
  const footer = document.querySelector('.footer');
  if (!footer) return;

  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

  const accordions = Array.from(footer.querySelectorAll('.footer__accordion'));
  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', () => {
      if (!mobileMediaQuery.matches || !accordion.open) return;
      accordions.forEach((other) => {
        if (other !== accordion) other.removeAttribute('open');
      });
    });
  });

  const newsletterForms = footer.querySelectorAll('.footer__newsletter-form');
  newsletterForms.forEach((form) => {
    form.addEventListener('submit', () => {
      const submitButton = form.querySelector('.footer__newsletter-submit');
      if (submitButton) submitButton.classList.add('is-submitting');
    });
  });
})();
